module.exports = __webpack_public_path__ + "img/closeIcon.743ec85e.svg";